interface TableBodyArguments extends React.HTMLAttributes<HTMLElement> {}

export function TableBody(props: TableBodyArguments) {
    return (
        <>
            {props.children}
        </>
    )
}